export enum SettingValueType {
  Json = 1,
  String = 2,
  Int = 3,
  Boolean = 4,
}
